/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdStudentData202,
  PutApiV1PersonIdStudentData400,
  PutApiV1PersonIdStudentData401,
  PutApiV1PersonIdStudentData404,
  PutApiV1PersonIdStudentData500,
  PutApiV1PersonIdStudentDataMutationRequest,
  PutApiV1PersonIdStudentDataMutationResponse,
  PutApiV1PersonIdStudentDataPathParams,
} from "../../types/personStudentController/PutApiV1PersonIdStudentData.ts";
import { personStudentDataViewModelSchema } from "../personStudentDataViewModelSchema.ts";
import { updateStudentDataViewModelSchema } from "../updateStudentDataViewModelSchema.ts";

export const putApiV1PersonIdStudentDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdStudentDataPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1PersonIdStudentData202Schema = z.lazy(
  () => personStudentDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdStudentData202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdStudentData400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdStudentData400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdStudentData401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdStudentData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdStudentData404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdStudentData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdStudentData500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdStudentData500>;

export const putApiV1PersonIdStudentDataMutationRequestSchema = z.lazy(
  () => updateStudentDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdStudentDataMutationRequest>;

export const putApiV1PersonIdStudentDataMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdStudentData202Schema,
) as unknown as ToZod<PutApiV1PersonIdStudentDataMutationResponse>;
